<script>
  import DeviceEdit from "./DeviceEdit.svelte";
  import devices from './stores/DeviceStore.js';
  export let deviceId;

  import loggedInUser from './stores/LoggedInUser.js';
  let loggedIn;
  $: { if($loggedInUser.user_id) {loggedIn = true} else {loggedIn = false} };
</script>

{#await devices.getOneImmutable(deviceId)} 
  <!-- fetching devices -->
{:then result}
    <DeviceEdit device={result.device} showDeleteButton={false} />
    {#if !loggedIn}
      <a href="/.auth/login/aad?post_login_redirect_uri=/?deviceId={result.device._id}&deviceEui={result.device.deviceEui}">Log in with Microsoft</a>
    {/if}
{:catch error}
  <p>{error}</p>
{/await}

